import React, { useState } from "react";
import EditorJs from "@natterstefan/react-editor-js";

import Moveable from "react-moveable";
import MoveableHelper from "moveable-helper";


import { EDITOR_JS_TOOLS } from "./constants";

import "./editor.styles.css";
import { editorData } from "./data";


const DimensionViewable = {
  name: "dimensionViewable",
  props: {},
  events: {},
  render(moveable, React) {
    const rect = moveable.getRect();
    // Add key (required)
    // Add class prefix moveable-(required)
    return (
      <div
        key={"dimension-viewer"}
        className={"moveable-dimension"}
        style={{
          position: "absolute",
          left: `${rect.width / 2}px`,
          top: `${rect.height + 20}px`,
          background: "#4af",
          borderRadius: "2px",
          padding: "2px 4px",
          color: "white",
          fontSize: "13px",
          whiteSpace: "nowrap",
          fontWeight: "bold",
          willChange: "transform",
          transform: "translate(-50%, 0px)",
        }}
      >
        {Math.round(rect.offsetWidth)} x {Math.round(rect.offsetHeight)}
        {/* <img
          src="https://images.unsplash.com/photo-1575089976121-8ed7b2a54265?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8ZGV2ZWxvcGVyfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
          alt=""
          style={{width: rect.width,
          height: rect.height}}
        /> */}
      </div>
    );
  },
};


const Editor = ({ data, onDragStop, onHandledelete , onSelected}) => {
  const [helper] = React.useState(() => {
    return new MoveableHelper();
  });
  const targetRRef = React.useRef(null);
  
  const [editorProp,] = useState({
    bgColor: "",
    strokeColor: "#fff",
    strokeWidth: 0,
    radius: "Non rounded",
  });

  let editor = null;
  const onSave = async () => {
    const outputData = await editor.save();
    console.log("outputData", outputData);
  };

  const onChange = (data) => {
    onSave();
  };

  // const getBackgroundColor = (color) => {
  //   setEditorProp({ ...editorProp, bgColor: color });
  // };

  // const getRadiusType = (type) => {
  //   console.log({ type });
  //   setEditorProp({ ...editorProp, radius: type });
  // };

  // const getStrokeWidth = (width) => {
  //   setEditorProp({ ...editorProp, strokeWidth: width });
  // };

  // const getStrokeColor = (color) => {
  //   setEditorProp({ ...editorProp, strokeColor: color });
  // };

  return (
    <div className={data.id} style={{ width: 700 }} >
      <div
        className="editor__space"
        style={{
          backgroundColor: editorProp?.bgColor?.hex,
          borderRadius: editorProp?.radius === "Non rounded" ? "" : 8,
          padding: editorProp?.bgColor?.hex ? 24 : 0,
          border: `${editorProp?.strokeWidth}px solid ${editorProp?.strokeColor.hex}`,
        }}
        ref={targetRRef}
      >
        <EditorJs
          editorInstance={(editorInstance) => {
            editor = editorInstance;
          }}
          data={editorData}
          tools={EDITOR_JS_TOOLS}
          onChange={onChange}
          holder="custom-editor-container"
        >
          {" "}
          <div
            id="custom-editor-container"
            style={{
              borderRadius: editorProp?.radius === "Non rounded" ? "" : 8,
            }}
          />
        </EditorJs>
      </div>
      <Moveable
        target={targetRRef }
        ables={[DimensionViewable]}
        props={{
          dimensionViewable: true,
        }}
        draggable={true}
        resizable={true}
        scalable={true}
        rotatable={true}
        onDragStart={helper.onDragStart}
        onDrag={helper.onDrag}
        onResizeStart={helper.onResizeStart}
        onResize={helper.onResize}
        onRotateStart={helper.onRotateStart}
        onRotate={helper.onRotate}
        onClick={onSelected}
      />
    </div>
  );
};

export default Editor;
